import { connect } from 'react-redux';
import PaymentCalculatorModalWrapper from '../components/views/loaded/PaymentCalculatorModalWrapper';

const mapStateToProps = (state, ownProps) => {
	return {
		isMobile: state.requestData.deviceType === 'MOBILE',
		name: ownProps.name
	};
};

export default connect(mapStateToProps)(PaymentCalculatorModalWrapper);
